/*
* Accommodation filter
*
*/
jQuery(document).ready(function($) {
    let ajaxUrl = ajax_callback_data.ajax_url;
    let ajaxNonce = ajax_callback_data.ajax_nonce;

    $('#accommodation-tax-state').change(function () {
        const selectedState = $(this).val();
        let form_data = new FormData();
        form_data.append('state-id', selectedState);
        form_data.append('accommodation-filter-nonce', ajaxNonce);
        
        if (selectedState) {
            $.ajax({
                url: ajaxUrl + '?action=accommodation_get_suburbs',
                xhrFields: {
                    withCredentials: true
                },
                type: 'POST',
                data: form_data,
                datatype: 'JSON',
                processData: false,
                contentType: false,
                beforeSend: function() {
                    ajaxLoaderShow();
                },
                success: function(response) {
                    var suburbSelect = $('#accommodation-tax-suburb');
                    suburbSelect.attr('disabled', false);
                    suburbSelect.empty();
                    suburbSelect.append('<option class="accommodation-cat value="" disabled selected>Select a suburb</option>');
                    suburbSelect.append('<option class="accommodation-cat value="">All</option>');
                    const suburbs = response?.data?.suburbs;
                    if (response?.success) {
                        $.each(response.data.suburbs, function (index, suburb) {
                            suburbSelect.append('<option value="' + suburb.term_id + '">' + suburb.name + '</option>');
                        });
                    }
                },
                complete: function() {
                    ajaxLoaderHide();
                },
                error: function () {
                    console.log('Error fetching suburb data. Please try again.');
                }
            });
        }
    });

});